import {
  IObjektVy,
  IObjektVyComp,
  IBusinessCollectionProps,
} from '../../../../../Types/ObjektVy';
import FakturaBilderComponent from './FakturaBilderComponent';

const FakturaBilderComp: IObjektVyComp = {
  caption: 'Fakturabilder',
  comp: (props: IBusinessCollectionProps) => {
    return (
      <FakturaBilderComponent
        {...props}
        noPadding
        menuCaption="Fakturabilder"
        useWheelToScroll={false}
      />
    );
  },
};

export const FakturaBilder: IObjektVy = {
  type: 'ObjektVy',
  id: 'FakturaBilder',
  info: { fullscreenInSideBySide: true, komponentMedRubrik: true },
  def: () => FakturaBilderComp,
};
